import { Grid, useMediaQuery } from '@material-ui/core';
import React from 'react';
import { useIntl } from 'react-intl';
import { RootStateOrAny, useSelector } from 'react-redux';
import { AssuranceIcon } from 'images';
import { get } from 'lodash';
import { StoreContext } from 'utils/contextStore';
import formatBytes from 'utils/formatBytes';
import CardRecapComponent from '../DeclareFolderProcess/CardRecapComponent';
import {
  ContentSecondTitle,
  ContentTitle,
  UploadBoxRecap,
  UploadBoxSecondTitle,
  UploadBoxTitle,
  FolderTypeSecondaryContent,
  PrimaryTitleCard,
} from '../DeclareFolderProcess/styles';

const Recap = () => {
  const intl = useIntl();
  const { PACProcessStepsState } = React.useContext(StoreContext);
  const setStep = PACProcessStepsState?.setPACProcessStep;
  const isNotMobile = useMediaQuery('(min-width:960px)');

  /* istanbul ignore next */
  const pacOrganismes = useSelector((state: RootStateOrAny) =>
    state.getIn(['pac', 'pacOrganismes']),
  );
  const pacObject = useSelector((state: RootStateOrAny) =>
    state.getIn(['pac', 'pacObject']),
  );

  /* istanbul ignore next */
  const getSelectedOrganismeName = () => {
    return pacOrganismes?.find(
      (org: { NUM_POLICE: any }) => org.NUM_POLICE === pacObject.numPolice,
    )?.NOM_SOUSCRIPTEUR;
  };

  return (
    <div style={{ maxHeight: isNotMobile ? 350 : 470, overflow: 'auto' }}>
      <CardRecapComponent
        action={
          /* istanbul ignore next */ () => {
            setStep(0);
          }
        }
        title={intl.formatMessage({
          id: 'Home_text_Health_declarer_une_personne_identite_step',
        })}
        content={
          <FolderTypeSecondaryContent>
            <PrimaryTitleCard>{getSelectedOrganismeName()}</PrimaryTitleCard>
          </FolderTypeSecondaryContent>
        }
      />

      <CardRecapComponent
        action={
          /* istanbul ignore next */ () => {
            setStep(1);
          }
        }
        title={intl.formatMessage({
          id: 'Home_text_Health_declarer_une_personne_step1',
        })}
        content={
          <FolderTypeSecondaryContent>
            <PrimaryTitleCard>{pacObject.category?.label}</PrimaryTitleCard>
          </FolderTypeSecondaryContent>
        }
      />
      <CardRecapComponent
        action={
          /* istanbul ignore next */ () => {
            setStep(2);
          }
        }
        title={intl.formatMessage({
          id: 'Home_text_Health_declarer_une_personne_step2',
        })}
        content={
          <FolderTypeSecondaryContent>
            <Grid
              style={{
                width: '90%',
                marginTop: 15,
                marginBottom: 15,
                marginLeft: 20,
              }}
              container
              alignItems="flex-start"
              direction="column"
            >
              <Grid item>
                <ContentSecondTitle fontSize="14px">
                  {intl.formatMessage({
                    id: 'signup_personal_info.last_name',
                  })}
                </ContentSecondTitle>
              </Grid>
              <Grid item>
                <ContentTitle fontSize="12px">{pacObject.Nom}</ContentTitle>
              </Grid>
            </Grid>
            <Grid
              style={{
                width: '90%',
                marginTop: 15,
                marginBottom: 15,
                marginLeft: 20,
              }}
              container
              alignItems="flex-start"
              direction="column"
            >
              <Grid item>
                <ContentSecondTitle fontSize="14px">
                  {intl.formatMessage({
                    id: 'signup_personal_info.first_name',
                  })}
                </ContentSecondTitle>
              </Grid>
              <Grid item>
                <ContentTitle fontSize="12px">{pacObject.Prenom}</ContentTitle>
              </Grid>
            </Grid>
            <Grid
              style={{
                width: '90%',
                marginTop: 15,
                marginBottom: 15,
                marginLeft: 20,
              }}
              container
              alignItems="flex-start"
              direction="column"
            >
              <Grid item>
                <ContentSecondTitle fontSize="14px">
                  {intl.formatMessage({
                    id: 'Home_text_Health_declarer_une_personne_sexe',
                  })}
                </ContentSecondTitle>
              </Grid>
              <Grid item>
                <ContentTitle fontSize="12px">
                  {intl.formatMessage({
                    id:
                      pacObject.Genre === 'F'
                        ? 'Home_text_Health_declarer_une_personne_female'
                        : 'Home_text_Health_declarer_une_personne_male',
                  })}
                </ContentTitle>
              </Grid>
            </Grid>
            <Grid
              style={{
                width: '90%',
                marginTop: 15,
                marginBottom: 15,
                marginLeft: 20,
              }}
              container
              alignItems="flex-start"
              direction="column"
            >
              <Grid item>
                <ContentSecondTitle fontSize="14px">
                  {intl.formatMessage({
                    id: 'signup_personal_info.birthday',
                  })}
                </ContentSecondTitle>
              </Grid>
              <Grid item>
                <ContentTitle fontSize="12px">
                  {pacObject.DateNaissanceFormatted}
                </ContentTitle>
              </Grid>
            </Grid>
            <Grid
              style={{
                width: '90%',
                marginTop: 15,
                marginBottom: 15,
                marginLeft: 20,
              }}
              container
              alignItems="flex-start"
              direction="column"
            >
              <Grid item>
                <ContentSecondTitle fontSize="14px">
                  {intl.formatMessage({
                    id: 'agent.phone',
                  })}
                </ContentSecondTitle>
              </Grid>
              <Grid item>
                <ContentTitle fontSize="12px">{pacObject.Gsm}</ContentTitle>
              </Grid>
            </Grid>
            <Grid
              style={{
                width: '90%',
                marginTop: 15,
                marginBottom: 15,
                marginLeft: 20,
              }}
              container
              alignItems="flex-start"
              direction="column"
            >
              <Grid item>
                <ContentSecondTitle fontSize="14px">
                  {intl.formatMessage({
                    id: 'id_memo.email',
                  })}
                </ContentSecondTitle>
              </Grid>
              <Grid item>
                <ContentTitle fontSize="12px">{pacObject.Email}</ContentTitle>
              </Grid>
            </Grid>
          </FolderTypeSecondaryContent>
        }
      />
      <CardRecapComponent
        action={
          /* istanbul ignore next */ () => {
            setStep(3);
          }
        }
        title={intl.formatMessage({
          id: 'Home_text_Health_declarer_une_personne_recap_docs',
        })}
        content={pacObject.TmpListFiles.map(
          /* istanbul ignore next */ (file: any, index: number) => (
            <UploadBoxRecap container style={{ marginBottom: 12 }}>
              <Grid item xs={2} style={{ maxWidth: 60 }}>
                <img src={get(AssuranceIcon, 'jpeg')} alt="jpeg" />
              </Grid>
              <Grid
                style={{ marginLeft: 5, marginRight: 5 }}
                item
                xs={8}
                sm={4}
              >
                <UploadBoxTitle>{'Document ' + (index + 1)}</UploadBoxTitle>
                <UploadBoxSecondTitle>
                  {formatBytes(file.file.size)}
                </UploadBoxSecondTitle>
              </Grid>
            </UploadBoxRecap>
          ),
        )}
      />
    </div>
  );
};

export default Recap;
